module.exports = __webpack_public_path__ + "static/img/ad.b2946bd8.svg";